import Web3 from "web3";

export enum WALLET_TYPES {
  NONE = "None",
  META_MASK = "MetaMask",
  WALLET_CONNECT = "WalletConnect",
  ALGO_SIGNER = "AlgoSigner",
  KEPLR = "Keplr",
  ZERION = "Zerion",
}
export interface WalletConnectorProps {
  WalletConnectView: any;
  WalletConnectModal: any;
  WalletConnectViewProps?: any;
}

export const initialWalletConnectorState = {
  isConnected: false,
  isConnecting: false,
  currentWallet: WALLET_TYPES.NONE,
  walletAddress: "",
  currentNetworkChainId: 0,
  walletBalance: "",
  rpcUrl: "",
  error: "",
  web3Sdk: undefined,
  isWeb3Initialized: false,
};

export const initialAlgoSignerWalletConnectorState = {
  isAlgoConnected: false,
  isAlgoConnecting: false,
  walletAddresses: [],
  connectedAlgorandWalletAddress: "",
  error: "",
  algoSdk: undefined,
  isAlgoSignerInitialized: false,
  currentLedger: undefined,
};

export const initialKeplrWalletConnectorState = {
  isKeplrConnected: false,
  isKeplrConnecting: false,
  keplrWalletAddresses: [],
  connectedKeplrWalletAddress: "",
  keplrWalletBalance: "",
  error: "",
  CosmWasmClient: undefined,
  keplrChainId: "",
};

export interface WalletConnectorState {
  isConnected: boolean;
  isConnecting: boolean;
  currentWallet: WALLET_TYPES;
  walletAddress: string;
  currentNetworkChainId: number;
  walletBalance: string;
  error: string;
  rpcUrl: string;
  web3Sdk: Web3 | undefined;
  isWeb3Initialized: boolean;
}

export interface WalletConnectorActions {
  catchWalletConnectError: (error: any) => void;
  setRPCUrl: (rpcUrl: string) => void;
  connectWallet: (currentWallet: WALLET_TYPES, rpcUrl: string) => void;
  walletConnected: (
    walletAddress: string,
    walletBalance: string,
    currentNetworkChainId: number,
    web3Sdk: Web3
  ) => void;
  resetWalletConnector: () => void;
}

export interface AlgoSignerWalletConnectorState {
  isAlgoConnected: boolean;
  isAlgoConnecting: boolean;
  walletAddresses: any[];
  connectedAlgorandWalletAddress: string;
  currentLedger: string | undefined;
  error: any;
  algoSdk: any | undefined;
  isAlgoSignerInitialized: boolean;
}

export interface AlgoSignerWalletConnectorActions {
  catchAlgoSignerWalletConnectError: (error: any) => void;
  algoSignerConnectWallet: (ledger: string) => void;
  connectAlgorandWalletAddress: (address: string) => void;
  algoSignerWalletConnected: (walletAddresses: any[], algoSdk: any) => void;
  resetAlgoSignerWalletConnector: () => void;
}

export interface KeplrWalletConnectorState {
  isKeplrConnected: boolean;
  isKeplrConnecting: boolean;
  keplrWalletAddresses: any[];
  connectedKeplrWalletAddress: string;
  keplrWalletBalance: string;
  error: any;
  CosmWasmClient: any | undefined;
  keplrChainId: string;
}

export interface KeplrSignerWalletConnectorActions {
  catchKeplrWalletConnectError: (error: any) => void;
  keplrConnectWallet: () => void;
  keplrWalletConnected: (
    keplrWalletAddresses: any[],
    keplrWalletBalance: string,
    keplrChainId: string,
    CosmWasmClient: any
  ) => void;
  resetKeplrWalletConnector: () => void;
}

export const cudosChainInfo = {
  chainId: "cudos-1",
  chainName: "CudosNetwork",
  rpc: "https://rpc.cudos.org",
  rest: "https://rest.cudos.org",
  stakeCurrency: {
    coinDenom: "CUDOS",
    coinMinimalDenom: "acudos",
    coinDecimals: 18,
    coinGeckoId: "cudos",
  },
  walletUrlForStaking: "https://explorer-v1.cudos.org/validators",
  bip44: {
    coinType: 118,
  },
  bech32Config: {
    bech32PrefixAccAddr: "cudos",
    bech32PrefixAccPub: "cudospub",
    bech32PrefixValAddr: "cudosvaloper",
    bech32PrefixValPub: "cudosvaloperpub",
    bech32PrefixConsAddr: "cudosvalcons",
    bech32PrefixConsPub: "cudosvalconspub",
  },
  currencies: [
    {
      coinDenom: "CUDOS",
      coinMinimalDenom: "acudos",
      coinDecimals: 18,
      coinGeckoId: "cudos",
    },
  ],
  feeCurrencies: [
    {
      coinDenom: "CUDOS",
      coinMinimalDenom: "acudos",
      coinDecimals: 18,
      gasPriceStep: {
        low: 5000000000000,
        average: 10000000000000,
        high: 20000000000000,
      },
    },
  ],
  coinType: 118,
  beta: true,
};
